<template>
    <div>
        <v-error-messages :has-frontend-errors="$v.$error" class="stack-l">
            <li class="list-item" v-if="!$v.userIds.requiredIf">
                When sharing with specific users you provide users to share with.
            </li>
        </v-error-messages>
        <p class="stack-m">You can share your segment with other users if you want.</p>
        <v-radio
            class="stack-m"
            group="sharing"
            :value="scopeValues.public"
            @update="updateScope"
            :model="scope">
            <template #label>
                <p>{{scopeLabels.public}}</p>
            </template>
        </v-radio>
        <v-radio
            class="stack-m"
            group="sharing"
            :value="scopeValues.private"
            @update="updateScope"
            :model="scope">
            <template #label>
                <p>{{scopeLabels.private}}</p>
            </template>
        </v-radio>
        <template v-if="$auth.users.read.isAllowed && hasUsers">
            <v-radio
                class="stack-m"
                group="sharing"
                :value="scopeValues.shared"
                @update="updateScope"
                :model="scope">
                <template #label>
                    <p>{{scopeLabels.shared}}</p>
                </template>
            </v-radio>
            <v-select
                :disabled="!isUserIdsNeeded"
                v-model="userIds"
                :options="options"
                multiple
                allow-empty
                option-key="id"
                option-label="name"
            />
        </template>
    </div>
</template>

<script>
    import {
        vRadio,
        vSelect,
        vErrorMessages,
    } from '@/components/form';
    import {requiredIf} from 'vuelidate/lib/validators';
    import {mapState} from 'vuex';
    import SegmentModel from '@/common/models/segment-model';

    export default {
        components: {
            vRadio,
            vSelect,
            vErrorMessages,
        },
        props: {
            value: {
                type: SegmentModel,
                required: true,
            },
        },
        watch: {
            scope() {
                this.triggerUpdate();
            },
            userIds() {
                this.triggerUpdate();
            },
        },
        data() {
            return {
                id: null,
                scope: null,
                userIds: null,
                scopeValues: {...SegmentModel.Scopes},
                scopeLabels: {...SegmentModel.ScopeLabels},
            };
        },
        computed: {
            ...mapState('users', ['users']),
            options() {
                return this.users.map(user => ({
                    id: user.id,
                    name: user.fullName,
                }));
            },
            hasUsers() {
                return this.users.length > 0;
            },
            isUserIdsNeeded() {
                return this.scope === SegmentModel.Scopes.shared;
            },
        },
        validations() {
            return {
                userIds: {
                    requiredIf: requiredIf(() => this.scope === this.scopeValues.shared),
                },
            };
        },
        methods: {
            async getData() {
                const {id, scope, users} = this.value;
                this.id = id;
                this.scope = scope;
                this.userIds = users.map(user => user.id);
                this.$v.$reset();
            },
            updateScope(scope) {
                this.scope = scope;
            },
            triggerUpdate() {
                const segmentToUpdate = new SegmentModel({...this.value});
                segmentToUpdate.scope = this.scope;
                segmentToUpdate.setUsersFromIds(this.userIds);
                this.$emit('update', segmentToUpdate);
            },
        },
        mounted() {
            this.getData();
        },
    };
</script>
